import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"

import en from "./locales/en.json"

export const SUPPORTED_LANGUAGES = ["en", "es"]

// English ships in the bundle because it is the fallback: every missing key falls back to it, so it
// has to be there before anything renders. Spanish is fetched when the player actually picks it.
const LOADERS = {
  es: () => import("./locales/es.json"),
}

const lazyLocales = {
  type: "backend",
  init: () => {},
  read(language, _namespace, callback) {
    const load = LOADERS[language]
    if (!load) {
      // English is already bundled, and an unsupported language has nothing to fetch.
      callback(null, {})
      return
    }
    load().then(
      (module) => callback(null, module.default),
      (error) => callback(error)
    )
  },
}

/** Resolves once the player's own dictionary is in memory. The first paint waits on it, so a
 *  Spanish player never sees a flash of English while their language is in flight. */
export const i18nReady = i18n
  .use(lazyLocales)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Only the fallback is preloaded; `partialBundledLanguages` is what lets the backend fetch the
    // rest instead of taking the bundled resources for the whole set.
    resources: { en: { translation: en } },
    partialBundledLanguages: true,
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: "en",
    // "es-ES" is Spanish; without this the detector's regional tag misses "es" and lands on English.
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "hvz-lang",
      caches: ["localStorage"],
    },
    // Render with whatever is loaded rather than suspending: English is always in memory, so a
    // component mounted mid-switch shows the fallback for a frame instead of nothing.
    react: { useSuspense: false },
    // Tests: init synchronously so the first render already has English.
    initImmediate: process.env.NODE_ENV !== "test",
  })

export default i18n
